import { render, staticRenderFns } from "./RequiredForOneClickOrder.vue?vue&type=template&id=a8b7a694&scoped=true&"
import script from "./RequiredForOneClickOrder.vue?vue&type=script&lang=js&"
export * from "./RequiredForOneClickOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b7a694",
  null
  
)

export default component.exports